import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { GET_API_CALL } from "../../utils/services";
import { ENDPOINTS } from "../../utils/endPoints";
import { FiSearch } from "react-icons/fi";
import { CFormLabel } from "@coreui/react";

export default function AsyncAutocomplete(props) {
  const {
    onSelect,
    name,
    placeHolder,
    changeHandler,
    value: search,
    label,
    selected: value,
    setSelected: setValue,
    url,
    disabled = false,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  // const [value, setValue] = React.useState(null);

  const fetchOptions = async (searchQuery = "") => {
    try {
      setLoading(true);
      const optionsFromGoogle = [];

      await GET_API_CALL(
        ENDPOINTS.CITIES.CITIES_LIST,
        `${searchQuery ? `${url}&searchKey=${searchQuery}` : url}`,
        (res) => {
          const dataToSave = [...optionsFromGoogle, ...(res?.data?.data || [])];
          console.log("combined options:", dataToSave);
          setOptions(dataToSave);
          setLoading(false);
        }
      );
    } catch (error) {
      console.error("Autocomplete fetch error:", error);
      setLoading(false);
    }
  };

  const handleOpen = () => {
    setOpen(true);
    fetchOptions(search); // Initial fetch if needed
  };

  const handleClose = () => {
    setOpen(false);
    setOptions([]);
  };

  const handleInputChange = (event, newInputValue) => {
    console.log("Input changed called:", newInputValue);
    changeHandler(newInputValue);
    fetchOptions(newInputValue);
  };

  return (
    <div className="w-100 ">
      <CFormLabel className="lable-text">{label}</CFormLabel>
      <Autocomplete
        disabled={disabled}
        size="small"
        open={open}
        fullWidth
        onOpen={handleOpen}
        onClose={handleClose}
        isOptionEqualToValue={(option, val) =>
          option?.cityName === val?.cityName
        }
        getOptionLabel={(option) => option?.cityName || ""}
        options={options}
        loading={loading}
        value={value}
        inputValue={search || ""}
        onInputChange={handleInputChange}
        onChange={(_, newValue) => {
          console.log("on change called:", newValue);
          setValue(newValue);
          onSelect(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            placeholder={placeHolder}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "38px", // total height of the field
                bgcolor: "white",
              },
              "& .MuiInputBase-input": {
                padding: "8px 14px", // adjust padding so text is centered vertically
                fontSize: "14px", // optional, to match proportion
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="error" size={20} />
                  ) : null}
                  <FiSearch />
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "zIndex",
                enabled: true,
                phase: "write",
                fn: ({ state }) => {
                  state.styles.popper.zIndex = "14000";
                },
              },
            ],
            sx: {
              zIndex: 14000,
              bgcolor: "white",
            },
          },
        }}
      />
    </div>
  );
}
